// extracted by mini-css-extract-plugin
export default {"gauge":"CloudCoverGauge_gauge__RtfzJ","temperature":"CloudCoverGauge_temperature__mnTXj","weather":"CloudCoverGauge_weather__oKIlY","mediumText":"CloudCoverGauge_mediumText__hE1X6"};